import { AxiosError } from 'axios';
import { useQuery } from '@tanstack/react-query';
import { getRegulationFeed } from '../api/api';
import { useEffect, useState } from 'react';
import {
  RegulationFeedList,
  getRegulationFeedFromXML,
} from '../utilities/RegulationFeedData';
import { State, apiStates } from '../types/types';
import { AlmaAccountActions } from '@almamedia-legal-insights/types';

export function useRegulationFeed(
  actions?: AlmaAccountActions,
  loading = true,
) {
  const [state, setState] = useState<State>(apiStates.FETCHING);
  const [apiError, setApiError] = useState<null | AxiosError>(null);
  const [regulationFeedList, setRegulationFeedList] =
    useState<RegulationFeedList>([]);

  const { isFetching, isError, error, data } = useQuery<string, AxiosError>({
    queryKey: ['articles'],
    queryFn: async () => getRegulationFeed(await actions?.getAccessToken()),
    enabled: !loading,
  });

  useEffect(() => {
    if (isFetching) {
      setApiError(null);
      setState(apiStates.FETCHING);
      return;
    }

    if (isError) {
      setApiError(error);

      setState(apiStates.HAS_ERROR);
      return;
    }

    try {
      setRegulationFeedList(getRegulationFeedFromXML(data));
      setState(apiStates.READY);
      setApiError(null);
    } catch {
      setState(apiStates.HAS_ERROR);
      return;
    }
  }, [isFetching, isError, data, error]);

  return {
    state,
    apiError,
    regulationFeedList,
  };
}
